var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.64523 19.6H11.4993C12.6344 19.6 13.5473 18.6249 13.5473 17.4374V17.0625C13.5473 16.7022 13.2698 16.4 12.916 16.4C12.5622 16.4 12.2848 16.7022 12.2848 17.0625V17.4374C12.2848 17.9044 11.9268 18.275 11.4993 18.275H2.64523C2.2177 18.275 1.85977 17.9044 1.85977 17.4374V7.31241C1.85977 6.84543 2.21768 6.475 2.64523 6.475H2.99931C3.35309 6.475 3.63056 6.17277 3.63056 5.8125C3.63056 5.45223 3.35309 5.15 2.99931 5.15H2.64523C1.51013 5.15 0.597266 6.12486 0.597266 7.31241V17.4374C0.597266 18.6249 1.51013 19.6 2.64523 19.6Z",
    fill: "#575BE8",
    stroke: "#575BE8",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94796 15.1H13.3855C14.5206 15.1 15.4333 14.125 15.4333 12.9375V3.56255C15.4333 2.37502 14.5206 1.4 13.3855 1.4H5.94796C4.81286 1.4 3.9 2.37501 3.9 3.56255V12.9375C3.9 14.125 4.81286 15.1 5.94796 15.1ZM5.1625 3.56255C5.1625 3.09554 5.52044 2.725 5.94796 2.725H13.3855C13.813 2.725 14.1708 3.09552 14.1708 3.56255V12.9375C14.1708 13.4045 13.813 13.775 13.3855 13.775H5.94796C5.52044 13.775 5.1625 13.4045 5.1625 12.9375V3.56255Z",
    fill: "#575BE8",
    stroke: "#575BE8",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copy-link.6ab58209ab3e07b460e968edf721765c.svg";
export { ForwardRef as ReactComponent };